import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import { Row } from './RequestData';
import { LandingPageData } from '../../../contexts/LandingPageContext';
import NoDataAvailable from '../../../components/NoDataAvailable';

function MyRequest({ title }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { requests: rows } = useContext(LandingPageData);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  console.log(title);

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            {(rows.length !== 0) && (
              <TableRow>
                <TableCell />
                <TableCell>Date</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Seller</TableCell>
                <TableCell>Status</TableCell>
                <TableCell />
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {(rows.length !== 0) && rows.map((row, index) => (
              <Row key={row.id} row={row} index={index} />
            ))}
            {(rows.length === 0) && (
              <NoDataAvailable />
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}
MyRequest.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MyRequest;
